import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import { IScheduleTimelineLeftSideColumn } from "../../../models"
import _ from "lodash"
import ReOrder from "material-ui/svg-icons/action/reorder"
interface IProps {
  items: any[]
  columns: IScheduleTimelineLeftSideColumn[]
  selectedItems: any[]
  selectable: boolean
  selectIdentityPropertyNames: string[]
  multiSelectable?: boolean
  showCheckboxes?: boolean
  hoveredRowNumber: number
  readonly: boolean
  allowDragDrop?: boolean
  dragDropRowId: string
  handelOnCellClick(rowNumber: number, colId: number): void
  handleOnRowSelection(result: any[] | string): void
  handleOnRowHover(rowNumber: number): void
  handleOnRowHoverExit(): void
  handleSetDragDropRowId(dragDropRowId: string): void
}

export default class TimelineTableLeftSide extends React.Component<IProps, {}>  {
  componentDidMount() {
    if (!this.props.allowDragDrop) return
    const checkBoxHeaderCol = document.getElementById("timeline_table_left_side_header_row").firstElementChild
    checkBoxHeaderCol.setAttribute("style", "padding: 5px; width: 30px;")
    const dragDropIconHeaderCol = document.getElementById("left_dragdrop_icon_header")

    dragDropIconHeaderCol.insertAdjacentElement("afterend", checkBoxHeaderCol)
    this.props.items.forEach(row => {
      const checkBoxCol = document.getElementById(`left_${row && row.Id}`).firstElementChild
      checkBoxCol.setAttribute("style", "padding: 5px; width: 30px;")
      const dragDropIconCol = document.getElementById(`left_dragdrop_icon_${row && row.Id}`)
      dragDropIconCol.insertAdjacentElement("afterend", checkBoxCol)
    })
  }

  render() {
    return (
      <Table
        allRowsSelected={this.props.items.length === this.props.selectedItems.length}
        multiSelectable={this.props.multiSelectable !== undefined ? this.props.multiSelectable : false}
        selectable={this.props.selectable !== undefined ? this.props.selectable : true}
        onCellClick={this.props.handelOnCellClick}
        onRowSelection={this.props.handleOnRowSelection}
        onRowHover={this.props.handleOnRowHover}
        onRowHoverExit={this.props.handleOnRowHoverExit}
      >
        <TableHeader
          displaySelectAll={this.props.showCheckboxes}
          adjustForCheckbox={this.props.showCheckboxes}
        >
          <TableRow
            id="timeline_table_left_side_header_row"
            style={{ borderTop: "1px solid rgb(224, 224, 224)" }}
          >
            {this.props.allowDragDrop &&
              <TableRowColumn id={`left_dragdrop_icon_header`} style={{ paddingLeft: 3, paddingRight: 0, width: 25 }} />
            }
            {this.props.columns.map((col, index) =>
              <TableHeaderColumn key={index} style={{ ...col.HeaderStyle }}>{col.HeaderLabel}</TableHeaderColumn>
            )}
          </TableRow>
        </TableHeader>
        <TableBody
          showRowHover={true}
          deselectOnClickaway={false}
          displayRowCheckbox={this.props.showCheckboxes}
          style={{ borderBottom: "1px solid rgb(224, 224, 224)" }}
        >
          {this.props.items.map((row, index) =>
            <TableRow
              data-intercom-target={`TimeLineTable-LeftSide-OpenEditShiftQuantityDialogForRow${index + 1}`}
              id={`left_${row && row.Id}`}
              key={index}
              style={{ visibility: this.props.dragDropRowId && this.props.dragDropRowId === this.props.items[index].Id ? "hidden" : "visible" }}
              selected={this.props.selectedItems && this.props.selectedItems.find((selectedItem) => compareObjects(this.props.selectIdentityPropertyNames, selectedItem, row)) ? true : false}
              hovered={this.props.hoveredRowNumber === index}
            >
              {this.props.allowDragDrop &&
                <TableRowColumn
                  id={`left_dragdrop_icon_${row && row.Id}`}
                  style={{ paddingLeft: 3, paddingRight: 0, width: 25 }}
                >
                  <ReOrder
                    style={{ width: 20, height: 20, paddingTop: 8 }}
                    onClick={() => this.props.handleSetDragDropRowId(row.Id)}
                    onMouseOver={() => this.props.handleSetDragDropRowId(row.Id)}
                  />
                </TableRowColumn>
              }
              {this.props.columns.map((col, colIndex) =>
                <TableRowColumn style={col.ColStyle} key={colIndex}>{col.Col(row)}</TableRowColumn>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
    )
  }
}

export function compareObjects(identitPropertyNames: string[], obj1: any, obj2: any): boolean {
  let obj1Identity = _.cloneDeep(obj1)
  let obj2Identity = _.cloneDeep(obj2)
  if (identitPropertyNames) {
    identitPropertyNames.forEach((propertyName) => {
      obj1Identity = obj1Identity[propertyName]
      obj2Identity = obj2Identity[propertyName]
    })
  }
  else {
    obj1Identity = obj1Identity.Id
    obj2Identity = obj2Identity.Id
  }
  return obj1Identity === obj2Identity
}